import "../src/css/anchor_tabs.css";

import certBasic from '../src/imgs/lateral_sections/certificacion_basica.svg';
import certIntermedia from '../src/imgs/lateral_sections/certificacion_intermedia.svg';
import certAvanzada from '../src/imgs/lateral_sections/certificacion_avanzada.svg';

import curLinea from '../src/imgs/lateral_sections/cursos_en_linea.svg';
import curMooc from '../src/imgs/lateral_sections/cursos_mooc.svg';
import curDiplomado from '../src/imgs/lateral_sections/diplomados.svg';

import doctorado from '../src/imgs/lateral_sections/doctorado.svg';
import maestria from '../src/imgs/lateral_sections/maestrias.svg';

export const AnchorTabsCertificaciones = () => {

  document.querySelectorAll('[id^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function(e){
          e.preventDefault();
          document.querySelector(this.getAttribute("to")).scrollIntoView({
            behavior : "smooth",
            block : "center"
          });
      });
  })

  return (

    <div className="menu_vinetas">
      <a className="vineta tab_anchor1" to='#section1' id="#section1">
        <img src={certBasic} alt="Certificación Básica" />
        <p>Certificación Básica</p>
      </a>
      <a className="vineta tab_anchor2" to='#section2' id="#section2">
        <img src={certIntermedia} alt="Certificación Básica" />
        <p>Certificación Intermedia</p>
      </a>
      <a className="vineta tab_anchor3" to='#section3' id="#section3">
        <img src={certAvanzada} alt="Certificación Básica" />
        <p>Certificación Avanzada</p>
      </a>
    </div>

  )
}

export const AnchorTabsCursos = () => {

  document.querySelectorAll('[id^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function(e){
        e.preventDefault();
        document.querySelector(this.getAttribute("to")).scrollIntoView({
          behavior : "smooth",
          block : "center"
        });
    });
  })

  return (

    <div className="menu_vinetas">
      <a className="vineta tab_anchor1" to='#section1' id="#section1">
        <img src={curMooc} alt="Certificación Básica" />
        <p>Cursos mLearning</p>
      </a>
      <a className="vineta tab_anchor2" to='#section2' id="#section2">
        <img src={curLinea} alt="Certificación Básica" />
        <p>Cursos eLearning</p>
      </a>
      <a className="vineta tab_anchor3" to='#section3' id="#section3">
        <img src={curDiplomado} alt="Certificación Básica" />
        <p>Diplomados</p>
      </a>
    </div>    

  )
}

export const AnchorTabsPosgrados = () => {

  document.querySelectorAll('[id^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function(e){
        e.preventDefault();
        document.querySelector(this.getAttribute("to")).scrollIntoView({
          behavior : "smooth",
          block : "center"
        });
    });
  })

  return (

    <div className="menu_vinetas">
      <a className="vineta tab_anchor1" to='#section1' id="#section1">
        <img src={maestria} alt="Certificación Básica" />
        <p>Maestria</p>
      </a>
      <a className="vineta tab_anchor2" to='#section2' id="#section2">
        <img src={doctorado} alt="Certificación Básica" />
        <p>Doctorado</p>
      </a>
    </div>    

  )
}